import loadProductsByID from '../../core/storefrontAPI/load-product-by-id';
import formatMoney from '../../core/formatMoney';

const getHeavy = (product_data) => {
  const tags_string = (typeof product_data.tags === 'undefined' || product_data.tags === null) ? '' : product_data.tags.join(',').toLowerCase();

  if (tags_string.includes('big')) {
    return `<input type="hidden" name="attributes[Heavy]" id="heavy-order" value="true" data-heavy-order>`;
  }

  return '';
};

const getFinalSale = (product_data) => {
  const tags_string = (typeof product_data.tags === 'undefined' || product_data.tags === null) ? '' : product_data.tags.join(',').toLowerCase();

  let final_sale = '<p class="product-details__message" tabindex="0" data-message="final-sale">Final Sale</p>';

  // Disabled - Now prepended to discount message
  // final_sale += '<input type="hidden" name="properties[Note]" id="final-sale-option" value="Final Sale" data-final-sale>';

  if (window.theme.promoMessage.finalSale === 'none') {
    final_sale = '';
  } else if (window.theme.promoMessage.finalSale === 'guests' && typeof window.theme.customer.id === 'undefined') {
    final_sale = '';
  } else if (window.theme.promoMessage.finalSale === 'loyalty' && typeof window.theme.customer.id !== 'undefined') {
    final_sale = '';
  }

  if (tags_string.includes('final sale') && final_sale !== '') {
    if (tags_string.includes('socialclub:final sale')) {
      if (typeof window.theme.customer.id === 'undefined') {
        final_sale = '';
      }
    }
  } else {
    final_sale = '';
  }

  return final_sale;
};

// Different promo message for logged-in/loyalty and guest customers
// (Almost) Same code as collection/productTileTemplateNosto.js
const getPromoMessageAndPrice = (product_data, data_type = 'message') => {
  if (window.theme.promoMessage.usOnly && window.Shopify.country !== 'US') {
    return '';
  }

  const is_search = document.body.classList.contains('has-overlay-search');

  // Promo applied by product tag or collection. Ignored when a promotion call out message has been defined for all products
  let promo_message = window.theme.promoMessage.guests;
  let promo_message_color = window.theme.promoMessage.color;
  let promo_discount = window.theme.promoMessage.guestPercentOff;
  let promo_discount_color = window.theme.promoMessage.colorPercentOff;
  let promo_tag = window.theme.promoMessage.tag;
  let promo_collection = window.theme.promoMessage.collection;

  // Variables for 2nd tag support
  let promo_message_2 = window.theme.promoMessage.guests2;
  const promo_message_color_2 = window.theme.promoMessage.color2;
  let promo_discount_2 = window.theme.promoMessage.guestPercentOff2;
  let promo_discount_color_2 = window.theme.promoMessage.colorPercentOff2;
  let promo_tag_2 = window.theme.promoMessage.tag2;

  // let special_message = '';
  const product_collections = product_data.collections.edges.map(item => item.node.handle) || [];

  // Promo applied to all products.
  if (window.theme.promoMessage.guestsAllProducts !== '') {
    promo_message = window.theme.promoMessage.guestsAllProducts;
    promo_message_color = window.theme.promoMessage.colorAllProducts;
  }

  if (window.theme.promoMessage.guestAllProductsPercentOff !== 0) {
    promo_discount = window.theme.promoMessage.guestAllProductsPercentOff;
    promo_discount_color = window.theme.promoMessage.colorAllProductsPercentOff;
  }

  if (window.theme.promoMessage.guestsAllProducts !== '' || window.theme.promoMessage.guestAllProductsPercentOff !== 0) {
    promo_tag = '';
    promo_collection = '';
    promo_tag_2 = '';
  }

  // Promo applied to loyalty members
  if (typeof window.theme.customer.id !== 'undefined') {
    promo_message = window.theme.promoMessage.loyalty;
    promo_discount = window.theme.promoMessage.loyaltyPercentOff;
    promo_discount_color = window.theme.promoMessage.colorPercentOff;

    promo_message_2 = window.theme.promoMessage.loyalty2;
    promo_discount_2 = window.theme.promoMessage.loyaltyPercentOff2;
    promo_discount_color_2 = window.theme.promoMessage.colorPercentOff2;

    // Promo applied to all products.
    if (window.theme.promoMessage.loyaltyAllProducts !== '') {
      promo_message = window.theme.promoMessage.loyaltyAllProducts;
      promo_message_color = window.theme.promoMessage.colorAllProducts;
    }

    if (window.theme.promoMessage.loyaltyAllProductsPercentOff !== 0) {
      promo_discount = window.theme.promoMessage.loyaltyAllProductsPercentOff;
      promo_discount_color = window.theme.promoMessage.colorAllProductsPercentOff;
    }

    if (window.theme.promoMessage.loyaltyAllProducts !== '' || window.theme.promoMessage.loyaltyAllProductsPercentOff !== 0) {
      promo_tag = '';
      promo_collection = '';
      promo_tag_2 = '';
    }
  }

  /*
  // Special message
  if (window.theme.promoMessage.specialMessage !== '') {
    if (typeof window.theme.customer.id === 'undefined') {
      if (window.theme.promoMessage.specialMessageCustomers === 'guests' || window.theme.promoMessage.specialMessageCustomers === 'all') {
        special_message = window.theme.promoMessage.specialMessage;
      }
    } else if (window.theme.promoMessage.specialMessageCustomers === 'members' || window.theme.promoMessage.specialMessageCustomers === 'all') {
      special_message = window.theme.promoMessage.specialMessage;
    }
  }

  special_message = special_message;
  */

  promo_message = promo_message;
  promo_message_2 = promo_message_2;

  // Special message, we need to make sure it only applies to the selected collection if any
  const special_message_html = '';
  /*
  if (special_message !== '') {
    let show_special_message = false;

    if (window.theme.promoMessage.specialMessageCollection === '') {
      show_special_message = true;
    } else {
      if (!is_search && document.querySelector('[data-collection-grid]') !== null) {
        if (window.theme.promoMessage.specialMessageCollection === document.querySelector('[data-collection-grid]').dataset.collection) {
          show_special_message = true;
        }
      }

      if (show_special_message === false && typeof product_collections !== 'undefined' && product_collections.length > 0) {
        for (let i = 0; i < product_collections.length; i++) {
          const collection = product_collections[i];

          if (collection === window.theme.promoMessage.specialMessageCollection) {
            show_special_message = true;
            break;
          }
        }
      }
    }

    if (show_special_message === true) {
      special_message_html = `<span class="product-tile__special-message" data-same-line="${window.theme.promoMessage.specialMessageSameLine}">${special_message}</span>`;
    }
  }
  */

  let promo_message_html = '';
  let promo_message_html_2 = '';

  if (data_type === 'message') {
    if (promo_message.length) {
      promo_message = `<span>${promo_message}</span>`;

      promo_message_html = `
        <p class="product-details__message" style="color: ${promo_message_color} !important;" tabindex="0" data-tag="1">${promo_message}${special_message_html}</p>
      `;
    }

    if (promo_message_2.length && promo_tag_2.length) {
      promo_message_2 = `<span>${promo_message_2}</span>`;

      promo_message_html_2 = `
        <p class="product-details__message" style="color: ${promo_message_color_2} !important;" tabindex="0" data-tag="2">${promo_message_2}${special_message_html}</p>
      `;
    }

    if (promo_message_html === '' && promo_message_2 === '' && special_message_html.length) {
      promo_message_html = `
        <p class="product-details__message" style="color: ${promo_message_color} !important;" tabindex="0" data-tag="1">${special_message_html}</p>
      `;
    }
  }

  if (data_type === 'price') {
    const first_variant_price = product_data?.variants?.edges[0]?.node?.price?.amount || 0;
    const before_price_text = (window.theme.promoMessage.promoBeforeText) ? `${window.theme.promoMessage.promoBeforeText} ` : '';
    const between_price_text = (window.theme.promoMessage.promoBetweenText) ? ` ${window.theme.promoMessage.promoBetweenText} ` : '';
    const after_price_text = (window.theme.promoMessage.promoAfterText) ? ` ${window.theme.promoMessage.promoAfterText}` : '';

    if (first_variant_price !== 0) {
      if (promo_discount !== 0) {
        const discounted_price = parseFloat((parseFloat(first_variant_price, 10) - ((parseFloat(first_variant_price, 10) * promo_discount) / 100))).toFixed(2);
        promo_message_html = `
          <p class="product-details__price-promo">
            <span class="product-details__promo" style="color: ${promo_discount_color} !important;">${before_price_text}${formatMoney(discounted_price, theme.moneyFormat)}${between_price_text}${promo_discount}%${after_price_text}</span>
          </p>
        `;
      }

      if (promo_discount_2 !== 0) {
        const discounted_price = parseFloat((parseFloat(first_variant_price, 10) - ((parseFloat(first_variant_price, 10) * promo_discount_2) / 100))).toFixed(2);
        promo_message_html_2 = `
          <p class="product-details__price-promo">
            <span class="product-details__promo" style="color: ${promo_discount_color_2} !important;">${before_price_text}${formatMoney(discounted_price, theme.moneyFormat)}${between_price_text}${promo_discount_2}%${after_price_text}</span>
          </p>
        `;
      }
    }
  }

  if (promo_tag === '' && promo_collection === '') {
    if (data_type === 'message' && promo_message_html === '' && special_message_html !== '') {
      return `<p class="product-details__message" style="color: ${promo_message_color} !important;" tabindex="0">${special_message_html}</p>`;
    }

    return promo_message_html;
  } else {
    // Message for specific tagged products or collections
    let show_promo_message = false;
    let show_promo_message_2 = false;

    if (promo_collection === '') {
      if (promo_tag !== '' || promo_tag_2 !== '') {
        for (let i = 0; i < product_data.tags.length; i++) {
          const tag = product_data.tags[i];

          if (promo_tag !== '') {
            if (tag.indexOf(promo_tag) !== -1) {
              show_promo_message = true;
              break;
            }
          }

          if (promo_tag_2 !== '') {
            if (tag.indexOf(promo_tag_2) !== -1) {
              show_promo_message_2 = true;
              break;
            }
          }
        }
      }
    } else {
      if (!is_search && document.querySelector('[data-collection-grid]') !== null) {
        if (promo_collection === document.querySelector('[data-collection-grid]')?.dataset?.collection) {
          show_promo_message = true;
        }
      }

      if (!show_promo_message && typeof product_collections !== 'undefined' && product_collections.length > 0) {
        for (let i = 0; i < product_collections.length; i++) {
          const collection_handle = product_collections[i];

          if (collection_handle === promo_collection) {
            show_promo_message = true;
            break;
          }
        }
      }

      // Case where promo 1 collection is set and promo 2 tag is set; promo 2 takes over
      if (promo_tag_2 !== '') {
        for (let i = 0; i < product_data.tags.length; i++) {
          const tag = product_data.tags[i];

          if (tag.indexOf(promo_tag_2) !== -1) {
            show_promo_message = false;
            show_promo_message_2 = true;
            break;
          }
        }
      }
    }

    if (show_promo_message === true) {
      if (data_type === 'message' && promo_message_html === '' && special_message_html !== '') {
        return `<p class="product-details__message" style="color: ${promo_message_color} !important;" tabindex="0">${special_message_html}</p>`;
      }

      return promo_message_html;
    } else if (show_promo_message_2 === true) {
      if (data_type === 'message' && promo_message_html_2 === '' && special_message_html !== '') {
        return `<p class="product-details__message" style="color: ${promo_message_color} !important;" tabindex="0">${special_message_html}</p>`;
      }

      return promo_message_html_2;
    } else if (data_type === 'message' && special_message_html !== '') {
      return `<p class="product-details__message" style="color: ${promo_message_color} !important;" tabindex="0">${special_message_html}</p>`;
    }
  }

  return '';
};

const getFlag = (product_data) => {
  let flag = '';

  // Priority: Stock alert > Best Seller app flag > Trending app flag > Style metafield flag > Tag-based flag

  const inventory_quantity = product_data.variants.edges.reduce((total, edge) => {
    const variant = edge.node;
    return total + Number(variant.quantityAvailable);
  }, 0);

  if (inventory_quantity <= 0) {
    flag = 'Out of Stock';
  }

  if (inventory_quantity > 0 && inventory_quantity < 3) {
    flag = 'Only a few left';
  }

  if (flag === '') {
    if (product_data.bestseller_30 !== null && product_data.bestseller_30 <= 30) {
      flag = 'Best Seller';
    }

    if (product_data.bestseller_14 !== null && product_data.bestseller_14 <= 30) {
      flag = 'Trending';
    }
  }

  // Tag-based flag
  // We don't show the final sale tags anymore, but they are needed to add a cart note
  if (flag === '') {
    const foundTag = (typeof product_data.tags === 'undefined' || product_data.tags === null) ? null : product_data.tags.find(tag => tag.includes('flag:') && !tag.toLowerCase().includes('final sale'));
    if (foundTag) flag = foundTag.replace('flag:', '');
  }

  return `<div class="product-details__flag" data-product-flag tabindex="0">${flag === '' ? '&nbsp;' : flag}</div>`;
};

const loadProductDetailsFromStorefrontAPI = async (product_id) => {
  try {
    console.log(`Load product details with ID ${product_id}`);
    const product_data = await loadProductsByID([product_id], true, true, true, true, true, true, true);

    if (!product_data.length) {
      return null;
    }

    return product_data[0].node;
  } catch (error) {
    console.log('Product loading error', error);
    return null;
  }
};

const getActions = (product_data, current_variant, edit_mode = false) => {
  let html = '';

  if (edit_mode) {
    return `
      <div class="product-actions">
        <div class="product-actions__update-container">
          <button
            class="btn btn--primary product-actions__update"
            type="button"
            name="update"
            data-quickview-update
            data-initial-variant-id="${window.theme.quickview.initialVariantId}"
            data-replace="false"
            aria-label="Update"
            tabindex="0">
              <span>Update</span>
          </button>
        </div>

        <div class="product-actions__view-details" tabindex="0" data-quickview-view-details data-quickview-view-details-base-link="${product_data.product_url}">
          <a href="${product_data.product_url}" title="${window.theme.strings.viewFullDetails}">${window.theme.strings.viewFullDetails}</a>
        </div>
      </div>
    `;
  }

  let add_to_bag_bt = `<span data-quickview-add-to-cart-available>${window.theme.strings.addToCart}</span>`;
  let sold_out_bt = `<span data-quickview-add-to-cart-unavailable>${window.theme.strings.soldOut}</span>`;

  if (current_variant.availableForSale == true) {
    sold_out_bt = `<span data-quickview-add-to-cart-unavailable class="visually-hidden" tabindex="-1" aria-hidden="true">${window.theme.strings.soldOut}</span>`;
  } else {
    add_to_bag_bt = `<span data-quickview-add-to-cart-available class="visually-hidden" tabindex="-1" aria-hidden="true">${window.theme.strings.addToCart}</span>`;
  }

  // const buy_now_button = `
  //   <div class="product-actions__buy-now-container" data-quickview-buy-now-container>
  //     <button
  //       class="btn btn--secondary product-actions__buy-now"
  //       type="button"
  //       name="buy-now"
  //       data-quickview-buy-now
  //       data-replace="false"
  //       aria-label="${window.theme.strings.buyNow}"
  //       disabled="disabled"
  //       tabindex="0">
  //         <span data-buy-now-text>${window.theme.strings.buyNow}</span>
  //     </button>
  //   </div>
  // `;
  // const buy_now_button = '';

  html = `
    <div class="product-actions">
      <div class="product-actions__add-to-cart-container">
        <button
          class="btn btn--primary product-actions__add-to-cart"
          type="button"
          name="add"
          data-quickview-add-to-cart
          data-replace="false"
          aria-label="${window.theme.strings.addToCart}"
          tabindex="0">
            <span data-quickview-add-to-cart-text>
              ${add_to_bag_bt}
              ${sold_out_bt}
            </span>
        </button>
      </div>

      <div class="product-actions__view-details" tabindex="0" data-quickview-view-details data-quickview-view-details-base-link="${product_data.product_url}">
        <a href="${product_data.product_url}" title="${window.theme.strings.viewFullDetails}">${window.theme.strings.viewFullDetails}</a>
      </div>
    </div>
  `;

  return html;
};

const getActionsWishlist = (product_data, current_variant) => {
  let html = '';

  html = `
    <div class="product-actions">
      <div class="product-actions__add-to-cart-container">
        <button
          class="btn btn--primary product-actions__add-to-wishlist"
          type="button"
          name="add"
          data-quickview-add-to-wishlist
          data-replace="false"
          aria-label="${window.theme.strings.addToWishlist}"
          tabindex="0">
            <span data-quickview-add-to-wishlist-text>
              ${window.theme.strings.addToWishlist}
            </span>
        </button>
      </div>

      <div class="product-actions__view-details" tabindex="0" data-quickview-view-details>
        <span class="swym-product-social-count" data-total-wishlisted></span> shoppers have already saved this style!
      </div>
    </div>
  `;

  return html;
};

export {
  getHeavy,
  getFinalSale,
  getPromoMessageAndPrice,
  getFlag,
  loadProductDetailsFromStorefrontAPI,
  getActions,
  getActionsWishlist,
};
